import { cn } from "@/common/utils/css.utils";
import { ComponentProps } from "react";
import { ElementProps } from "@/common/contracts/input.contracts";

type InputLabelProps = Omit<ComponentProps<"label">, "valid"> & ElementProps;

/**
 * Label component for input fields.
 *
 * @param className List of CSS classes to pass to the label tag.
 * @param props Rest of the label props.
 */
export const InputLabel = ({
  className,
  valid: _valid,
  ...props
}: InputLabelProps) => {
  return (
    <label
      className={cn("font-body text-base text-black", className)}
      {...props}
    />
  );
};
